import { GESTOCK_PLANS } from "../config/subscriptions"

export type GestockFeature = keyof typeof GESTOCK_PLANS.FREE.features

export function normalizePlan(plan: string | undefined | null) {
  const key = String(plan || "").toUpperCase()
  return GESTOCK_PLANS[key as keyof typeof GESTOCK_PLANS] ? key : "FREE"
}

export function getCurrentPlan(userdata: any) {
  return normalizePlan(userdata?.subscription?.currentPlan || userdata?.user?.plan)
}

export function hasFeature(
  userPlan: string | undefined | null,
  feature: GestockFeature
) {
  const plan = GESTOCK_PLANS[normalizePlan(userPlan) as keyof typeof GESTOCK_PLANS]
  return plan?.features?.[feature] === true
}

export function getPlanLimits(userPlan: string | undefined | null) {
  const plan = GESTOCK_PLANS[normalizePlan(userPlan) as keyof typeof GESTOCK_PLANS]
  return plan?.limits || { maxProducts: 20 }
}

export function getMaxProducts(userPlan: string | undefined | null) {
  const max = getPlanLimits(userPlan).maxProducts
  return max === null ? null : Number(max)
}

export function canAddProduct(userPlan: string | undefined | null, currentProductsCount: number) {
  const max = getMaxProducts(userPlan)
  if (max === null) return true
  return Number(currentProductsCount || 0) < max
}

export function getSmsPlanPricing(userPlan: string | undefined | null) {
  const plan = GESTOCK_PLANS[normalizePlan(userPlan) as keyof typeof GESTOCK_PLANS]
  const sms = (plan as any)?.limits?.sms || {}

  return {
    canSend: Boolean(sms.canSend),
    monthlyIncluded: Number(sms.monthlyIncluded || 0),
    overagePrice: Number(sms.overagePrice || 0),
  }
}
